export enum OverrideDefinitionType {
  byInstance = 1,
  byPeriod = 2,
  retroactive = 3
}
